import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2/dist/sweetalert2.js'

export default class Modalsentedit extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   id_room:"",
   name_room:"",
   amount:"",
   id:"",
   building:[],
   building_id:'',

}

//this.handleChange = this.handleChange.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleChange3 = this.handleChange3.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
this.handleChange4 = this.handleChange4.bind(this);
this.getbuilding = this.getbuilding.bind(this);
this.onChange = this.onChange.bind(this);

}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
  this.props.getclassroom();
  const { id_send } = this.props.name_room
      console.log(id_send);
      this.setState({ id_room:this.props.id_send})
      this.setState({ name_room:this.props.name_room})
      this.setState({ amount:this.props.amount})
      this.setState({ id:this.props.id})
 this.getbuilding()   

}


 componentDidMount() {
      const { id_send } = this.props.id_send
      console.log(id_send);
      this.setState({ id_room:this.props.id_send})
      this.setState({ name_room:this.props.name_room})
      this.setState({ amount:this.props.amount})
      this.setState({ id:this.props.id})
  }

  getbuilding() {

     setTimeout(() => {
      //ภายใน
       Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getbuilding')
         // Axios.get('https://research.kpru.ac.th/Api_Research/index/research_search')
      .then(res => {
     //   console.log(res);
      //  this.setState({ bankname: res.data, loading: false })
        this.setState({ building: res.data})
        this.setState({ loading: false})
      }) 
    }, 0);

  }


  onChange(value) {
     console.log(`selected ${value}`);




 // Axios.get('https://mua.kpru.ac.th/FrontEnd_Mis/employee/procSEmpInfo/'+value)
  //  .then(res => {
     // console.log(res.data.procSEmpInfo[0].citizen_id);
    //  this.setState({ bankname: res.data, loading: false })
   //   this.setState({ citizen_id: res.data.procSEmpInfo[0].citizen_id})
   //   this.setState({ idemp: res.data.procSEmpInfo[0].employee_id})
   //   this.setState({ employee_name: res.data.procSEmpInfo[0].employee_name})
  //  })

       const building_id = value;
       this.setState({ building_id });
}


  handleChange2(event) {    this.setState({id_room: event.target.value});  }
  handleChange3(event) {    this.setState({name_room: event.target.value});  }
  handleChange4(event) {    this.setState({amount: event.target.value});  }


  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id_room", this.state.id_room);
      datafrm.append("name_room", this.state.name_room);
      datafrm.append("amount", this.state.amount);
      datafrm.append("id", this.state.id);
      datafrm.append("building_id", this.state.building_id);
    
      
   Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/updateroom/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
    //    console.log(res);
        if (res.status === 200) {
        //  alert("บันทึกสำเร็จ")
                  Swal.fire({
                      title: 'บันทึกข้อมูลสำเร็จ',
                      icon: 'success',
                    // showCancelButton: true,
                      confirmButtonText: 'ตกลง',
                    // cancelButtonText: 'No, keep it'
                    }).then((result) => {
                      this.props.getclassroom();
                    })
                 }
        })
        this.toggle()
        this.props.getclassroom()

}, 2000);

//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()
 
  }

    render() {
     //   console.log(this.state.id_room)
     //   console.log(this.state.name_room)
      //  console.log(this.state.amount)
        
        return (
          <MDBContainer>
            <MDBBtn onClick={this.toggle} color="deep-purple" size="sm"><MDBIcon icon="edit" /> แก้ไข</MDBBtn>
            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}>แก้ไขข้อมูลห้องเรียน</MDBModalHeader>
              <MDBModalBody>
              <div>

              {/* <p>{this.state.id_send}</p>
              <p>{this.state.name_room}</p> */}
               <p>รหัสห้อง </p>   
               <MDBInput type="text" label="รหัสห้อง" value={this.state.id_room} onChange={this.handleChange2} outline />

               <p>ชื่อห้อง </p>
               <MDBInput type="text" label="ชื่อห้อง" value={this.state.name_room} onChange={this.handleChange3} outline />

               <p>ชื่ออาคาร </p>

                 <Select
                       
                    showSearch
                    style={{ width: 400 }}
                    placeholder="เพิ่มข้อมูลห้อง"
                    optionFilterProp="children"
                    onChange={this.onChange}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                >
                   
                   {this.state.building.map((building,index )  => 
                   <option value={building.building_id}>{building.building_name}</option>
                   )}
                  </Select>
                  <p></p>

                  {/* <div>
                  <select className="browser-default custom-select" label="รหัสห้อง">
          <option>Choose your option</option>
          <option value="1">Option 1</option>
          <option value="2">Option 2</option>
          <option value="3">Option 3</option>
        </select>
      </div> */}

               <p>จำนวนที่นั่ง </p>   
               <MDBInput type="text" label="จำนวนที่นั่ง" value={this.state.amount} onChange={this.handleChange4} outline />
              
              </div>
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
          
        )
    }
}


// https://kpruinnovation.kpru.ac.th/inno2022/download/_24ผู้ช่วยศาสตราจารย์ราตรี-โพธิ์ระวัช1.pdf